import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getPdfListForUpload = async (payload) => {
  const builder = new UrlBuilder(`/get-pdfs`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const uploadPdf = async (payload) => {
  const builder = new UrlBuilder(`/save-pdfs`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const uploadOverlay = async (payload) => {
  const builder = new UrlBuilder(`/save-overlays`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const deleteUploadedDoc = async (payload) => {
  const builder = new UrlBuilder(`/delete-pdfs`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
